import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import './footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import Input from '../../Elements/Inputs/Input';
import Button from '../../Elements/Buttons/Button';
import { COTIZACION_FORM } from '../../Constants/Forms/Cotizacion';
import { cotizacionSchema } from '../../Models/Forms/cotizacionSchema';
import useForm from '../../Hooks/UseForm';
import { setErrorFormSimpleUtil } from '../../Utilities/Forms/errors';
import { footerData } from '../../../json/layout/footer';

const Footer = () => {
  const [isClient, setIsClient] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    isValid,
    resetForm,
  } = useForm(COTIZACION_FORM, cotizacionSchema);

  const iconMap = {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaTiktok
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  const currentYear = new Date().getFullYear();
  const bottomText = footerData.footerCopy?.textoCopy.replace('{{year}}', currentYear);

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/send-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      const result = await response.json();

      if (response.ok) {
        resetForm();
        await Swal.fire({
          icon: "success",
          title: footerData.alertas?.alertaSuccess?.titulo,
          text: footerData.alertas?.alertaSuccess?.texto,
          confirmButtonColor: footerData.alertas?.alertaSuccess?.colorBoton,
          confirmButtonText: footerData.alertas?.alertaSuccess?.textoBoton,
        }).then(() => {
          setLoading(false);
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: footerData.alertas?.alertaError?.titulo,
          text: result.message || footerData.alertas?.alertaError?.texto,
          confirmButtonColor: footerData.alertas?.alertaError?.colorBoton,
          confirmButtonText: footerData.alertas?.alertaError?.textoBoton,
        }).then(() => {
          setLoading(false);
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos conectar con el servidor.",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      }).then(() => {
        setLoading(false);
      });
    }
  };

  return (
    <footer className="footer container-fluid">
      <div id='footer-hdr' className="footer-content row">
        <div className='col-md-4 center-info'>
          <div
            className="imag-footer-logo"
            style={{
              width: '100%',
              height: '100px',
              backgroundImage: `url('/assets/imgs/footer/LOGO.svg')`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          />
        </div>
        <div className="footer-form col-md-4">
          <h3 dangerouslySetInnerHTML={{ __html: footerData.footerCotizacion?.tituloPrincipal }}></h3>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[0]?.formText}
              variant="Simple"
              value={values.name}
              onChange={handleChange('name')}
              onBlur={handleBlur('name')}
              error={setErrorFormSimpleUtil(errors, touched, 'name')}
              success={!setErrorFormSimpleUtil(errors, touched, 'name')}
            />

            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[1]?.formText}
              variant="Simple"
              value={values.email}
              onChange={handleChange('email')}
              onBlur={handleBlur('email')}
              error={setErrorFormSimpleUtil(errors, touched, 'email')}
              success={!setErrorFormSimpleUtil(errors, touched, 'email')}
            />

            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[2]?.formText}
              variant="Simple"
              value={values.phone}
              onChange={handleChange('phone')}
              onBlur={handleBlur('phone')}
              error={setErrorFormSimpleUtil(errors, touched, 'phone')}
              success={!setErrorFormSimpleUtil(errors, touched, 'phone')}
            />

            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[3]?.formText}
              variant="Simple"
              value={values.serviceType}
              onChange={handleChange('serviceType')}
              onBlur={handleBlur('serviceType')}
              error={setErrorFormSimpleUtil(errors, touched, 'serviceType')}
              success={!setErrorFormSimpleUtil(errors, touched, 'serviceType')}
            />

            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[4]?.formText}
              variant="Simple"
              value={values.address}
              onChange={handleChange('address')}
              onBlur={handleBlur('address')}
              error={setErrorFormSimpleUtil(errors, touched, 'address')}
              success={!setErrorFormSimpleUtil(errors, touched, 'address')}
            />

            <Input
              placeholder={footerData.footerCotizacion?.footerCotizacionData[5]?.formText}
              variant="Textarea"
              value={values.message}
              onChange={handleChange('message')}
              onBlur={handleBlur('message')}
              error={setErrorFormSimpleUtil(errors, touched, 'message')}
              success={!setErrorFormSimpleUtil(errors, touched, 'message')}
            />
            <Button
              text={loading ? "Sending..." : footerData.footerCotizacion?.botonTexto}
              action={() => handleSubmit(values)}
              disabled={!isValid || loading}
              fill
              color="black"
            />
          </div>
        </div>
{/*         <div className="footer-left col-md-2">
          <h3>{footerData?.footerInformation?.titulo}</h3>
          {
            footerData?.footerInformation?.links.map((item, index) => (
              <div className='content-footer-information'>
                <a href={item.url}>{item.title}</a>
              </div>
            ))
          }
        </div> */}
        <div className='col-md-4 data-contact-footer'>
          <div className='row'>
            <div className='col-12'>
              <div className="footer-contact-container">
                <h3>{footerData.footerContacto?.titulo}</h3>
                {footerData.footerContacto?.footerContactoData.map((detail, index) => {
                  return (
                    <div key={index} className="contact-detail">
                      <span className='casper-normal'>{detail.titulo}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <div className="footer-socials">
                <h3 dangerouslySetInnerHTML={{ __html: footerData.footerContacto?.tituloRedesSociales }}></h3>
                <div className='content-footer-socials'>
                  {footerData.footerContacto?.redesSociales.map((social, index) => {
                    const Icon = iconMap[social.icono];
                    return (
                      <a key={index} href={social.link} target='_blank' rel="noreferrer" className={`icon ${social.plataforma}`}>
                        {Icon && <Icon />}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span className='casper-normal'>{bottomText}</span>
      </div>
    </footer>
  );
};

export default Footer;
